
    /**
    * 分销员业绩列表
    **/
      
  import request, {AxiosPromise} from '@utils/request'
  export class IReqid18168 {
  /**
   * bd组名
   */
  name?: string | number;
  /**
   * 组编号
   */
  bdGroupCode?: string | number;
  bdCode?: string | number;
  /**
   * 省份province_id
   */
  provinceCode?: string | number;
  index?: string | number;
  size?: string | number;
}
  /**
 * YResult<YListData<BdMonthGmvInfoDto>> :YResult
 */
export class IResid18168 {
  code?: {};
  msg?: {};
  success?: {};
  /**
   * YListData
   */
  data?: {
    /**
     * T
     */
    list?: {
      /**
       * gmv
       */
      gmv?: {};
      /**
       * 月
       */
      month?: {};
      /**
       * bd
       */
      bdCode?: {};
    }[];
    totalNumber?: {};
    rowId?: {};
  };
  exceptionMsg?: {};
}
  type Serve<T, G> = (data?: T) => AxiosPromise<G>
  const http: Serve<IReqid18168, IResid18168['data'] > = (data?) =>  request({
        method: 'GET',
        url: '/bdGroup/list/bdMonthGmv',
        params: data
      }) 
  export default http